export enum Language {
  DEFAULT = "en-GB",
  EN = "en-GB",
  DE = "de-DE",
}

export default Language;
